import { Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { MaterialPageGrid } from '../../../../utils/material-page-grid';
import { FormBuilder } from '@angular/forms';
import { AccountService } from '../../../../services/account.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PortalProductsService } from '../../../../services/portal-products.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpService } from '../../../../services/http.service';
import { Subscription } from 'rxjs';
import * as moment from 'moment';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-cals-portfolio',
  templateUrl: './cals-portfolio.component.html',
  styleUrls: ['./cals-portfolio.component.scss'],
})
export class CalsPortfolioComponent implements OnInit, OnDestroy {
  defaultPageGridSize = 10;
  @Input() accountType;
  @Input() customerId;
  division = 'cals';
  calsPortfolioPageGrid: MaterialPageGrid;
  downloadingReport = false;

  calsPortfolioGridInProgress: boolean;

  calsClientDetails: any;
  equityPortfolio: any;
  paramInvestorCode = null;
  displayedColumns = [
    'instrumentCode',
    'totalStock',
    'saleable',
    'avgCost',
    'totalCost',
    'marketRate',
    'marketValue',
    'unrealizedGain',
    'gainPercentage',
    'marketValuePercentage',
  ];
  calsPortfolioSortFieldList = [
    {
      id: 1,
      name: 'Portfolio Value - Lowest',
      sortField: 'portfolioValue,asc',
    },
    {
      id: 2,
      name: 'Portfolio Value - Highest',
      sortField: 'portfolioValue,desc',
    },
    {
      id: 3,
      name: 'No. of Shares - Lowest',
      sortField: 'quantity,asc',
    },
    {
      id: 2,
      name: 'No. of Shares - Highest',
      sortField: 'quantity,desc',
    },
  ];
  investmentCodeTemp = null;
  unSubscribe: Subscription;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private fb: FormBuilder,
    private accountService: AccountService,
    private router: Router,
    private portalProductsService: PortalProductsService,
    private http: HttpClient,
    private httpService: HttpService,
    private cdRef: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute
  ) {
    this.unSubscribe = this.activatedRoute.parent.params.subscribe(async (params) => {
      this.paramInvestorCode = params['investorCode'];
      if (this.calsPortfolioPageGrid) {
        await this.initializeCALSGrid();
      }
      // this.loadPageData(params['investorCode']);
    });
  }

  async ngOnInit() {
    await this.initializeCALSGrid();
    this.cdRef.detectChanges();
  }

  async downloadReport(downloadUrl: string) {
    this.downloadingReport = true;
    this.cdRef.detectChanges();
    // let downloadURL = this.httpService.baseApiUrl + this.httpService.baseApiPath + '/live-market-data/download-stock-tracker-data-pdf';
    try {
      let data = await this.get(downloadUrl);
      this.downloadFile(data, 'Portfolio Summary - ' + moment(new Date()).format('YYYY-MM-DD') + '.pdf');
      this.downloadingReport = false;
      this.cdRef.detectChanges();
    } catch (e) {
      this.downloadingReport = false;
      this.cdRef.detectChanges();
    }
  }

  downloadFile = (blob, fileName) => {
    const link = document.createElement('a');
    // create a blobURI pointing to our Blob
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    // some browser needs the anchor to be in the doc
    document.body.append(link);
    link.click();
    link.remove();
    // in case the Blob uses a lot of memory
    setTimeout(() => URL.revokeObjectURL(link.href), 1);
  };

  get(url: string, data?: any) {
    const token = localStorage['atk'];
    let formattedUrl = this.httpService.baseApiUrl + this.httpService.baseApiPath + url;
    let headers = new HttpHeaders().set('Authorization', token && 'Bearer ' + token);

    return this.http.get(formattedUrl, { headers, responseType: 'blob' }).toPromise();
  }

  async initializeCALSGrid() {
    // console.log(this.paramInvestorCode)
    if (this.paramInvestorCode === this.investmentCodeTemp) {
      return;
    }
    this.investmentCodeTemp = this.paramInvestorCode;
    // const displayedColumns = this.dis.map((col) => col.field);
    this.calsPortfolioPageGrid = new MaterialPageGrid(this.fb, this.defaultPageGridSize)
      .setTableColumns(this.displayedColumns)
      .setSource(async (listQuery) => {
        let count = 0;
        this.calsPortfolioGridInProgress = true;
        this.cdRef.detectChanges();

        try {
          // Get count first
          let equityCount = await this.portalProductsService.getEquityPortfolioCount(this.paramInvestorCode);
          count = equityCount.count;

          // Get data if count > 0
          let data = [];
          if (count > 0) {
            this.equityPortfolio = await this.portalProductsService.getEquityPortfolio(
              this.paramInvestorCode,
              listQuery.pageIndex,
              listQuery.pageSize,
              listQuery.sortField
            );
            data = this.equityPortfolio?.equityDetailList || [];
          }

          this.calsPortfolioGridInProgress = false;
          this.cdRef.detectChanges();
          console.log('Portfolio data:', data);
          return { data, total: count };
        } catch (e) {
          this.calsPortfolioGridInProgress = false;
          this.cdRef.detectChanges();
          return { data: [], total: 0 };
        }
      })
      .setFilters({});
    console.log(this.calsPortfolioPageGrid, 'grid');
    this.cdRef.detectChanges();

    setTimeout(() => {
      if (this.paginator) {
        console.log('Attaching paginator');
        this.calsPortfolioPageGrid.attachPaginator(this.paginator);
      } else {
        console.warn('Paginator not available at this time');
      }
      if (this.calsPortfolioPageGrid && this.sort) {
        this.calsPortfolioPageGrid.attachSort(this.sort);
      }
    }, 1500);
  }

  selectionSortField(value): void {
    this.calsPortfolioPageGrid.sortField = '';
    this.cdRef.detectChanges();
  }

  switchToTransactions(stockId) {
    this.accountService.emitStockId(stockId);
  }
  gotoResearchPortal(stockId) {
    this.router.navigate([`/research-portal/stocks/overview`], { queryParams: { id: `${stockId}` } });
  }
  // tslint:disable-next-line:member-ordering
  rowCallback = (({ dataItem }) => {
    if (dataItem.gainPercentage > 0) {
      return { increased: true };
    }
    if (dataItem.gainPercentage < 0) {
      return { decreased: true };
    }
  }).bind(this);

  ngOnDestroy() {
    this.unSubscribe.unsubscribe();
  }
}
